import { useMemo } from "react"
import type { PreOrderEmail } from "@stockline/shared/types/orders/pre-order-email"
import { PRE_ORDER_EMAIL_TABLE } from "../../../lib/offline/resources/orders/pre-order-email/db"
import { useAISync } from "../../ai/providers/AISyncProvider"

export interface UsePreOrderEmailsFilter {
  preOrderId?: string
  emailId?: string
  includeDeleted?: boolean
}

export function usePreOrderEmails(
  filter?: UsePreOrderEmailsFilter
): PreOrderEmail[] {
  const { reactive } = useAISync()
  const rows = reactive.useQuery<PreOrderEmail>(PRE_ORDER_EMAIL_TABLE, {
    ...(filter?.preOrderId ? { preOrderId: filter.preOrderId } : {}),
    ...(filter?.emailId ? { emailId: filter.emailId } : {}),
    orderBy: "-createdAt",
  })
  // Memoize the filtered slice so the returned array reference stays stable
  // across renders when the underlying Dexie query is unchanged. Inline
  // .filter() returns a fresh array every render and breaks consumer
  // useMemo dependencies (caused a Maximum-update-depth loop in earlier
  // iterations of usePreOrdersForChat).
  const includeDeleted = filter?.includeDeleted === true
  return useMemo(
    () => (includeDeleted ? rows : rows.filter((r) => !r.deletedAt)),
    [rows, includeDeleted]
  )
}
